<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="app-main-inner-row">
        <div class="triggers">
          <span style="font-size: 12px;">{{ $t('sysManage.baseConfig.singleOnlineSetting.branchId') }}：</span>
          <el-select v-model="searchConditions.branchId" style="width: 160px;" @change="changeQueryParam">
            <el-option
              v-for="office in currentOfficeList"
              :key="office.uuid"
              :value="office.officeId"
              :label="office.code"
            />
          </el-select>
          <el-radio-group v-model="searchConditions.docType" style="margin: 0 10px;" @change="changeQueryParam">
            <el-radio label="MBL" style="margin-right: 10px;">MBL</el-radio>
            <el-radio label="HBL">HBL</el-radio>
          </el-radio-group>
          <el-button type="warning" @click="reset">{{
            $t('common.btn.reset') }}
          </el-button>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="260303"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from '@/utils/auth'
import { deepCloneMethod } from '@/utils'
import {
  getSingleOnlineSettingList,
  saveSingleOnlineSetting,
  resetSingleOnlineSetting
} from '@/api/sysManage/baseConfig/singleOnlineSetting'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'SettingUpOfShippingOnlineCounter',
  components: {},
  data() {
    return {
      fullscreenLoading: null,
      searchConditions: {
        branchId: this.$store.getters.currentOfficeId,
        docType: 'MBL'
      },
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        }, {
          headerName: this.$t('sysManage.baseConfig.singleOnlineSetting.fieldCode'),
          field: 'fieldCode',
          width: 200
        }, {
          headerName: this.$t('sysManage.baseConfig.singleOnlineSetting.fieldName'),
          field: 'fieldName',
          width: 200
        }, {
          headerName: this.$t('sysManage.baseConfig.singleOnlineSetting.fclEdit'),
          field: 'fclEdit',
          width: 150,
          cellRendererFramework: 'CargoGridOptCheckBox',
          onCellValueChanged: p => this.onCellChange(p)
        }, {
          headerName: this.$t('sysManage.baseConfig.singleOnlineSetting.lclEdit'),
          field: 'lclEdit',
          width: 150,
          cellRendererFramework: 'CargoGridOptCheckBox',
          onCellValueChanged: p => this.onCellChange(p)
        }
      ],
      rowData: [],
      originRowData: [],
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false
      }
    }
  },
  computed: {
    currentOfficeList() {
      return getUserInfo().currentUserOfficeList
    }
  },
  mounted() {
    this.fetchSingleOnlineSettingList()
  },
  methods: {
    fetchSingleOnlineSettingList() {
      const self = this
      self.fullscreenLoading = getLoading()
      const params = { ...this.searchConditions }
      getSingleOnlineSettingList(params).then(results => {
        self.rowData = results.data
        self.originRowData = deepCloneMethod(self.rowData)
      }).finally(() => {
        self.fullscreenLoading.close()
      })
    },
    changeQueryParam() {
      this.fetchSingleOnlineSettingList()
    },
    dataFilter() {
      const originData = this.originRowData
      const newData = this.rowData
      const editData = []
      for (let i = 0, len = originData.length; i < len; i++) {
        if (originData[i]['fclEdit'] !== newData[i]['fclEdit'] || originData[i]['lclEdit'] !== newData[i]['lclEdit']) {
          editData.push(newData[i])
        }
      }
      const addData = editData.filter(data => !data['uuid'])
      const updateData = editData.filter(data => !!data['uuid'])
      return { addData, updateData }
    },
    save() {
      const self = this
      self.fullscreenLoading = getLoading()
      const filterData = self.dataFilter()
      const data = {
        branchId: self.searchConditions.branchId,
        docType: self.searchConditions.docType,
        addSingleOnlineSettings: filterData.addData,
        updateSingleOnlineSettings: filterData.updateData
      }
      saveSingleOnlineSetting(data).then(() => {
        self.$message.success(self.$t('common.tips.saveSuccess'))
        self.fetchSingleOnlineSettingList()
      }).finally(() => {
        self.fullscreenLoading.close()
      })
    },
    reset() {
      const self = this
      self.fullscreenLoading = getLoading()
      const data = { ...self.searchConditions }
      resetSingleOnlineSetting(data).then(() => {
        self.$message.success(self.$t('common.tips.resetSuccess'))
        self.fetchSingleOnlineSettingList()
      }).finally(() => {
        self.fullscreenLoading.close()
      })
    },
    onCellChange(params) {
      this.save()
    }
  }
}
</script>
